// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function globalOffset(el: {
    getBoundingClientRect: () => { top: any; left: any };
}) {
    const { top, left } = el.getBoundingClientRect();
    const { pageYOffset, pageXOffset } = window;

    return {
        top: top + pageYOffset,
        left: left + pageXOffset,
    };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function isPointerInside(el: any, { pageX, pageY }: any) {
    const { left, top } = globalOffset(el);
    const { offsetWidth, offsetHeight } = el;

    return (
        pageX >= left &&
        pageX <= left + offsetWidth &&
        pageY >= top &&
        pageY <= top + offsetHeight
    );
}
